<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="foreword" id="_idContainer001" role="doc-foreword">
<p class="pl-fl-roman"><i>USA TODAY</i> bestselling author <b>Ruth Logan Herne </b>loves God, her country, her family, dogs, chocolate and coffee! Married to a very patient man, she lives in an old farmhouse in upstate New York and thinks possums should leave the cat food alone and snakes should always live outside. There are no exceptions to either rule! Visit Ruth at <a href="http://ruthloganherne.com" target="_blank">ruthloganherne.com</a>.</p>
<p class="pl-fl-roman">Award-winning author <b>Myra Johnson</b> writes emotionally gripping stories about love, life and faith. She is a two-time finalist for the ACFW Carol Award and winner of the 2005 RWA Golden Heart® Award. Married since 1972, Myra and her husband have two married daughters and seven grandchildren. Although Myra is a native Texan, she and her husband now reside in North Carolina, sharing their home with two pampered rescue dogs.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// About_the_Author.vue?70f8e9e0